<div class="dialogContainer" [ngClass]="{'visible': showDialog }">
  <div class="dialog">
    @if (message) {
      <div class="message" [innerHtml]="message | safeHtml"></div>
    }
    <div class="grid-x margin-top" [formGroup]="form">
      <div class="cell small-4 padding-right text-align-right bold">
        Required Bonding:
      </div>
      <div class="cell small-4">
        <input type="number" min="0" formControlName="bondingAmount" />
      </div>
      <div class="cell small-4">&nbsp;</div>
      <div class="cell small-4 padding-right text-align-right bold">
        Required Date:
      </div>
      <div class="cell small-4">
        <common-date-picker [id]="'requiredDate'" (dateUpdated)="requiredDateUpdated($event)" [initialDate]="form?.get('requiredDate')?.value"></common-date-picker>
      </div>
      <div class="cell small-4">&nbsp;</div>
      <div class="cell small-12 italic red">
        Submitting this form without a required date or amount will void any existing bonding requirements.<br />
        To cancel an existing bonding requirement, submit a new bonding requirement with an amount of $0.00.<br />
        Submitted changes will not be committed until the 'Save' button is used.
      </div>
    </div>
    <div class="dialogButtonsContainer">
      <div class="text-align-center">
        <button class="button margin-left no-margin-bottom outline-offset-1" (click)="cancel()">Cancel</button>
        <button class="button margin-left no-margin-bottom outline-offset-1" (click)="submit()">Submit</button>
      </div>
    </div>
  </div>
</div>